module.exports = __webpack_public_path__ + "static/media/starfarm-mobile-preview.06d2a13e.png";